export var CallbackStatus;
(function (CallbackStatus) {
    CallbackStatus["FAILED"] = "not_ok";
    CallbackStatus["NOTSTARTED"] = "not_started";
    CallbackStatus["SUCCESS"] = "ok";
    CallbackStatus["VIPPS"] = "1";
})(CallbackStatus || (CallbackStatus = {}));
